import { Component, NgZone, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../shared/services/api.service';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';

@Component({
  standalone: false,
  selector: 'app-country-currency',
  templateUrl: './country-currency.component.html',
  styleUrl: './country-currency.component.scss'
})
export class CountryCurrencyComponent {

  count = 0;
  dataObj: any = {};
  modalRef: any;
  gridApi: any;
  content: any;
  type = 'country';

  columnDefs: ColDef[] = [
    {
      headerName: 'Action',
      field: 'action',
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-outline-success', 'ps-4', 'pe-4', 'rounded-pill');
        button.innerHTML = `Edit`;
        button.addEventListener('click', () => this.onEdit(params));
        return button;
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      editable: true,
      filter: true,
    },
    {
      headerName: 'Country',
      field: 'name',
      editable: true,
      filter: true,
    },
    {
      headerName: 'Currency',
      field: 'currency',
      editable: true,
      filter: true,
    },

  ];

  gridOptions: any = {
    paginationPageSize: 20,
    cacheBlockSize: 20,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [10, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };


  constructor(
    private _modal: NgbModal,
    private _api: ApiService,
     private zone: NgZone
  ) { }

  ngOnInit(): void {

  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
    }
  }

  refreshGrid() {
    const vm = this;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;

        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };

        let queryParams = [
          '_page=' + request._page,
          '_limit=' + request._limit,
        ];

        // Handle filters
        const filterModel = params.filterModel;
        for (const field in filterModel) {
          const filter = filterModel[field];
          if (filter.filter) {
            queryParams.push(`${field}=${encodeURIComponent(filter.filter)}`);
          }
        }

        const apiUrl = '/admin/get-data?type=' + vm.type + '&' + queryParams.join('&');
        console.log(apiUrl);

        vm._api.getData(apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.count;
            console.log(vm.count);
            console.log(res);
            res.data = res.data.map((r: any) => {
              r.currency = r.name === 'India' ? 'INR' : 'USD';
              return r;
            });
            params.successCallback(res.data, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  addNew(content: any) {
    const vm = this;
    vm.dataObj = {};
    //this.content = content;
    console.log(vm.content);
    vm.modalRef = vm._modal.open(this.content, { backdrop: 'static', size: 'lg' });
  }

  // onEdit(data: any) {
  //   const vm = this;
  //   console.log(vm.content);
  //   vm.dataObj = data.data;
  //   vm.modalRef = vm._modal.open(this.content, { backdrop: 'static', size: 'lg' });
  // }

  onEdit(data: any) {
    this.zone.run(() => {
      this.dataObj = data.data;
      console.log(this.dataObj, 'datattt');
      this.modalRef = this._modal.open(this.content, { backdrop: 'static', size: 'lg' });
    });
  }


  setContent(c: any) {
    this.content = c;
  }

   onSubmit(flag: any) {
    this.dataObj['type'] = this.type;
    console.log(this.dataObj);
    this._api.postData('/admin/new-data', this.dataObj).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res && !res.error) {
          this.onClose();
          this.dataObj = {};
        } else {
          // Show error message from backend
          alert(res.message || 'Failed to save country');
        }
      },
      error: (err: any) => {
        console.error('Error saving country:', err);
        alert(err || 'Failed to save country');
      }
    });
  }

   onClose() {
    if (this.modalRef) {
      this.modalRef.close();
    }
    // Refresh grid to reflect changes
    this.refreshGrid();
  }

}
